import { Base } from '../../abstract/base.model';
import { isRecord } from '../utils/is-record';
import { nullableBoolean, nullableString } from '../utils/wire-value-utils';
import { CustomNameType } from './custom-name-type.model';

/**
 * A custom name or alias on an EPA chemical (`customNames` of `/admin/epa-chemicals/:id`). Added and removed
 * through their own routes; unsent fields stay `undefined`.
 */
export class EpaChemicalCustomName extends Base {
  chemicalId?: string | null;
  name?: string | null;
  isPrimary?: boolean | null;
  nameType?: CustomNameType | null;
  createdBy?: string | null;

  constructor(data: unknown) {
    super(data);
    const source = isRecord(data) ? data : {};
    this.chemicalId = nullableString(source['chemicalId']);
    this.name = nullableString(source['name']);
    this.isPrimary = nullableBoolean(source['isPrimary']);
    this.nameType = nullableString(source['nameType']) as CustomNameType | null | undefined;
    this.createdBy = nullableString(source['createdBy']);
  }
}
